import { files } from "@/firebase.js";
import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false
  },
  mutations: {
    setList(state, organizations) {
      state.list = organizations;
    },
    setListLoading(state, loading) {
      state.listLoading = loading;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let organizations = await api.get("organizations");
      commit("setList", organizations.data);
      commit("setListLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("organizations", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put("organizations", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async grantAccessUser({ commit }, payload) {
      let response = [];
      await api
        .post("user/grantOrgUser", payload)
        .then(result => {
          if (result.data.Result == "Success") {
            response = {
              Result: "Success",
              Response: result.data
            };
          } else {
            response = {
              Result: "Failed",
              Response: result.data
            };
          }
        })
        .catch(error => {
          response = {
            Result: "Error",
            Response: error
          };
        });

      return response;
    },

    async grantAccessAdmin({ commit }, payload) {
      let response = [];
      await api
        .post("user/grantOrgAdmin", payload)
        .then(result => {
          if (result.data.Result == "Success") {
            response = {
              Result: "Success",
              Response: result.data
            };
          } else {
            response = {
              Result: "Failed",
              Response: result.data
            };
          }
        })
        .catch(error => {
          response = {
            Result: "Error",
            Response: error
          };
        });

      return response;
    }
  },
  getters: {
    listLoading(state) {
      return state.listLoading;
    },
    list(state) {
      return state.list;
    }
  }
};
